import React from 'react';
import { Link, Stack } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router';
import { IBackLink } from './interfaces';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const BackLink: React.FC<IBackLink> = ({
  route,
  children,
  sx,
}): JSX.Element => {
  const location = useLocation();

  const getLink = (baseRoute: string): string => {
    const from = location.state?.from;

    if (from && from.startsWith(baseRoute)) {
      return from;
    }

    return baseRoute;
  };

  return (
    <Link component={RouterLink} to={getLink(route)} underline="hover" sx={sx}>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <ArrowBackIcon fontSize="small" />
        {children}
      </Stack>
    </Link>
  );
};
